import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Martín Rodríguez',
    role: 'Diseñador Gráfico',
    city: 'Córdoba',
    text: 'Mandé 8 mensajes del Pack de Reactivación el lunes. El miércoles tenía 3 conversaciones abiertas y el viernes cerré 1 cliente.'
  }, {
    name: 'Camila Fernández',
    role: 'Community Manager',
    city: 'Buenos Aires',
    text: 'Llevaba 3 semanas sin que entrara nada. El Capítulo 4 me hizo escribirle a 5 ex-clientes. Dos respondieron y uno contrató.'
  }, {
    name: 'Lucía Mammone',
    role: 'Arquitecta',
    city: 'Mendoza',
    text: 'En 10 días: 15 mensajes enviados, 6 respuestas, 3 propuestas abiertas, 2 cierres. La inversión se pagó sola.'
  }];
  return <section className="py-24 bg-white border-y border-neutral-200" data-id="element-313">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-314">
        <div className="text-center mb-16" data-id="element-315">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-316">
            Lo que dicen los que ya lo aplicaron
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-317">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream rounded-xl p-8 border border-neutral-200 shadow-sm flex flex-col" data-id="element-318">
              <div className="flex gap-1 mb-6" data-id="element-319">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-brand-500 text-brand-500" data-id="element-320" />)}
              </div>
              <p className="text-neutral-700 text-lg mb-8 flex-grow italic font-display" data-id="element-321">
                "{t.text}"
              </p>
              <div className="border-t border-neutral-200 pt-4" data-id="element-322">
                <p className="font-bold text-neutral-900" data-id="element-323">{t.name}</p>
                <p className="text-brand-600 text-sm" data-id="element-324">
                  {t.role} · {t.city}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};